/* global process */
// Polyfills
import 'react-app-polyfill/ie11';
import 'core-js/es6/map';
import 'core-js/es6/set';
import 'core-js/fn/string/includes';
import 'core-js/fn/array/find';
import 'core-js/fn/array/flat-map';
import 'core-js/es7/array';
import 'core-js/es7/object';

// Global CSS
import 'react-toastify/dist/ReactToastify.css';
import './index.css';
import 'styles/toast.css';
import 'styles/modal.css';

import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { createStore, compose, applyMiddleware } from 'redux';
import { Router } from 'react-router-dom';
import thunkMiddleware from 'redux-thunk';
import createBrowserHistory from 'history/createBrowserHistory';

import Helmet, { HelmetProvider } from 'react-helmet-async';
import { ToastContainer } from 'react-toastify';
import CloseButton from 'components/CloseButton';
import Routes from 'routes';

// Redux
import reducers from 'store/reducers';
import Analytics from 'helpers/Analytics';

/**
 * Using Google Translate breaks react. This is a workaround for that issue until Chrome fixes the bug
 * More information: https://github.com/facebook/react/issues/11538
 */
import translateWorkaround from 'helpers/TranslateWorkaround';
translateWorkaround();

// Rework the Poland logo header link if M2 header is being used with a desktop view
if (document.body.clientWidth >= 640 && window.location.pathname.includes('pl/pl')) {
    const link = document.querySelector('.header__logo');
    if (link && link.href.includes('://m2.')) {
        link.href = link.href.replace('://m2.', '://www.');
    }
}

// Polyfill Element.prototype.matches() / .closest() for IE
// https://developer.mozilla.org/en-US/docs/Web/API/Element/closest#Polyfill
if (!Element.prototype.matches) {
    Element.prototype.matches = Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
}
if (!Element.prototype.closest) {
    Element.prototype.closest = selector => {
        var el = this;
        do {
            if (el.matches(selector)) return el;
            el = el.parentElement || el.parentNode;
        } while (el !== null && el.nodeType === 1);
        return null;
    };
}

// Setup token-service without the need of injecting a script in the browser
if (process.env.NODE_ENV === 'development' && process.env.REACT_APP_LOCALHOST_TOKEN_SERVICE_ENV_OVERRIDE) {
    const [, countryCode, languageCode] = /\/(\w{2})\/(\w{2})\/.*/g.exec(window.location.pathname) || [];
    if (countryCode) {
        require('@ikea-devframework/client-token-service').setup(
            process.env.REACT_APP_LOCALHOST_TOKEN_SERVICE_ENV_OVERRIDE,
            countryCode,
            languageCode,
        );
    }
}

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

// Be sure to ONLY add this middleware in development!
const middleware = process.env.NODE_ENV === 'development' ?
    [require('redux-immutable-state-invariant').default(), thunkMiddleware] :
    [thunkMiddleware];

const store = createStore(
    reducers,
    composeEnhancers(
        applyMiddleware(...middleware)
    )
);

// Link history API
const history = createBrowserHistory();
window.appHistory = history;

// Initialise analytics
window.Checkout.analytics = new Analytics();
window.appHistory.listen(() => {
    window.Checkout.analytics.logPageView();
});

// Expose store to cypress tests
if (window.Cypress) {
    window.Checkout.store = store;
}

ReactDOM.render(
    <Provider store={store}>
        <HelmetProvider>
            <ToastContainer
                closeOnClick={false}
                closeButton={<CloseButton container="toast" />}
                autoClose={6000}
            />
            <Helmet titleTemplate="%s - IKEA" defaultTitle="IKEA" />
            <Router history={history}>
                <Routes />
            </Router>
        </HelmetProvider>
    </Provider>,
    document.getElementById('one-checkout')
);
